import PHOTO0 from "../../../../common/assets/images/Montronix/Model/WifiboxNG.png";
import PHOTO1 from "../../../../common/assets/images/Montronix/Model/SpectraNG.png";
import PHOTO2 from "../../../../common/assets/images/Montronix/Model/PulseNG.png";
import PHOTO3 from "../../../../common/assets/images/Montronix/Model/IBU-NG.png";
import PHOTO4 from "../../../../common/assets/images/Montronix/Model/Baumer_StrainLink.png";

import CIRCLE1 from "../../../../common/assets/images/Montronix/Model/CircleVIdeo1.svg";
import CIRCLE2 from "../../../../common/assets/images/Montronix/Model/CircleVIdeo2.svg";
import CIRCLE3 from "../../../../common/assets/images/Montronix/Model/CircleVIdeo3.svg";
import CIRCLE4 from "../../../../common/assets/images/Montronix/Model/CircleVIdeo4.svg";
import CIRCLE5 from "../../../../common/assets/images/Montronix/Model/CircleVIdeo5.svg";

import POINT from "../../../../common/assets/images/Montronix/Model/Pointer.png";

import { Html, Preload } from "@react-three/drei";
import { Suspense, useEffect, useRef, useState } from "react";
import { Canvas } from "@react-three/fiber";
import { CameraControls } from "../logic/logic";
import { Modal } from "../../../../common/UI/Modal/molecules/Modal";
import { PhotoModalSecond } from "../../../../common/UI/Modal/molecules/ModalPhoto";
import { NavMenuMontronix } from "../../../../common/UI/NavMenu/organoids/NavMenuMontronix";
import { CameraTurnButton } from "../molecules/ButtonCameraTurn";
import { Scene } from "../molecules/Scene";
import { useStore } from "effector-react";
import {
  $modelChoise,
  setmodelChoise,
} from "../../../../common/UI/GuideButtons/logic/GuideLogic";
import { Ipoint2D, ISetForModal } from "../../../../common/interfaces";
import {
  Baumer,
  IBUNG,
  PulseNG,
  WifiboxNG,
  SpectraNG,
} from "../atoms/ModelPoints";
import { extend } from "@react-three/fiber";
import { titleName } from "../../../../common/function";
import { setmodelPage } from "../../../../common/hooks";

import "../../../style/ModelGeneralPage/animation.css";
import { CircularProgress } from "@mui/material";

extend({ CameraTurnButton });

export const ModelPageMontronix = () => {
  const [hovered, setHover] = useState<boolean>(false);
  const [selected, setSelected] = useState<string>("");
  const [selectedHover, setSelectedHover] = useState<boolean>(false);
  const [forModal, setForModal] = useState<ISetForModal>({} as ISetForModal);
  const [active, setActive] = useState(false);
  const [activeSecond, setActiveSecond] = useState(false);
  const [modalPoints, setModalPoints] = useState<Ipoint2D[] | null>(null);
  const [helper, setHelper] = useState<boolean>(false);
  const canvasRef = useRef();
  const [points, setPoints] = useState(WifiboxNG);
  const modelChoise = useStore($modelChoise);
  const [readenModelSlidesNew, setreadenModelSlidesNew] = useState(0);
  const [, setlengthModelSlidesNew] = useState(5);

  setmodelPage(false);

  titleName("Montronix");

  useEffect(() => {
    if (modelChoise === 0) {
      setPoints(WifiboxNG);
      setlengthModelSlidesNew(WifiboxNG.length);
    } else if (modelChoise === 1) {
      setPoints(SpectraNG);
      setlengthModelSlidesNew(SpectraNG.length);
    } else if (modelChoise === 2) {
      setPoints(PulseNG);
      setlengthModelSlidesNew(PulseNG.length);
    } else if (modelChoise === 3) {
      setPoints(IBUNG);
      setlengthModelSlidesNew(IBUNG.length);
    } else if (modelChoise !== 1) {
      setPoints(Baumer);
      setlengthModelSlidesNew(Baumer.length);
    }
  }, [modelChoise, points]);

  useEffect(() => {
    setreadenModelSlidesNew(readenModelSlidesNew);
  }, [readenModelSlidesNew]);

  useEffect(() => {
    setTimeout(() => {
      setSelectedHover(false);
    }, 10000);
  }, [selectedHover]);

  useEffect(() => {
    if (!active) {
      setForModal({
        title: "",
        img: "",
        imgArray: [""],
        posX: 0,
        posY: 0,
        text: [""],
        modalType: 0,
      });
      setSelected("");
    }
  }, [active]);

  const setPositionFor = (
    eX: number,
    eY: number,
    img: string,
    title: string,
    text: string,
    imgArray: string[],
    modalType: number,
    list?: { title: string; quotes: string[] }[]
  ) => {
    setForModal({
      title: title,
      img: img,
      imgArray: imgArray,
      posX: eX,
      posY: eY,
      text: [text],
      modalType: modalType,
      list: list,
    });
    setActive(true);
  };

  return (
    <div className="Canvas" style={{ height: "100vh" }}>
      <div
        style={{
          height: "83vh",
          width: "auto",
        }}
      >
        <div className="Page_BlockTitle">
          {modelChoise === 0
            ? "WiFi BoxNG"
            : modelChoise === 1
            ? "SpectraNG"
            : modelChoise === 2
            ? "PulseNG"
            : modelChoise === 3
            ? "IBU-NG"
            : "StrainLink250-DA"}
        </div>
        <Canvas //@ts-ignore
          ref={canvasRef}
          // camera={{fov: 30}}
        >
          {/* <color attach="background" args={["rgba(236, 236, 236,1)"]} /> */}
          <Suspense
            fallback={
              <Html>
                <CircularProgress />
              </Html>
            }
          >
            <Scene
              setHelper={setHelper}
              setSelected={setSelected}
              setPosition={setPositionFor}
              selected={selected}
              setModalPoints={setModalPoints}
              points={points}
              setSelectedHover={setSelectedHover}
            />
            <Preload all />
          </Suspense>
          <CameraControls modelChoise={modelChoise} />
        </Canvas>
      </div>
      <PhotoModalSecond
        title={forModal.title}
        text={forModal.text}
        content={forModal.imgArray}
        active={activeSecond}
        setActive={setActiveSecond}
      />
      {helper ? (
        <img
          className="withGrayWaves"
          src={POINT}
          alt=""
          style={{
            position: "absolute",
            top: "50%",
            left: "30%",
            height: "40px",
          }}
        />
      ) : (
        <></>
      )}
      <Modal
        active={hovered}
        setHover={setHover}
        image={[forModal.img]}
        points={modalPoints}
        title={forModal.title}
        list={forModal.list}
      />

      <NavMenuMontronix
        nextUrl={""}
        backUrl={"/montronix/video"}
        visibleFlag={"/montronix/model"}
      />
      <div className="button_model_all">
        <button
          onClick={() => setmodelChoise(0)}
          className={
            modelChoise === 0
              ? "button_video_choise borderNavMen"
              : "visiblBlock button_video_choise"
          }
          style={{
            textAlign: "center",
          }}
        >
          <div className="icon_2d__Montronix-Model">
            <img src={CIRCLE1} style={{ height: "100%" }} alt="" />
          </div>
          <img
            src={PHOTO0}
            style={{ background: "50% 50% no-repeat" }}
            alt=""
            className="button_model_all_img"
          />
        </button>
        <button
          onClick={() => setmodelChoise(1)}
          className={
            modelChoise === 1
              ? "button_video_choise borderNavMen"
              : "visiblBlock button_video_choise"
          }
          style={{
            textAlign: "center",
          }}
        >
          <div className="icon_2d__Montronix-Model">
            <img src={CIRCLE2} style={{ height: "100%" }} alt="" />
          </div>
          <img
            src={PHOTO1}
            style={{ background: "50% 50% no-repeat" }}
            alt=""
            className="button_model_all_img"
          />
        </button>
        <button
          onClick={() => setmodelChoise(3)}
          className={
            modelChoise === 3
              ? "button_video_choise borderNavMen"
              : "visiblBlock button_video_choise"
          }
          style={{
            textAlign: "center",
          }}
        >
          <div className="icon_2d__Montronix-Model">
            <img src={CIRCLE3} style={{ height: "100%" }} alt="" />
          </div>
          <img
            src={PHOTO3}
            style={{ background: "50% 50% no-repeat" }}
            alt=""
            className="button_model_all_img"
          />
        </button>
        <button
          onClick={() => setmodelChoise(2)}
          className={
            modelChoise === 2
              ? "button_video_choise borderNavMen"
              : "visiblBlock button_video_choise"
          }
          style={{
            textAlign: "center",
          }}
        >
          <div className="icon_2d__Montronix-Model">
            <img src={CIRCLE4} style={{ height: "100%" }} alt="" />
          </div>
          <img
            src={PHOTO2}
            style={{ background: "50% 50% no-repeat" }}
            alt=""
            className="button_model_all_img"
          />
        </button>
        <button
          onClick={() => setmodelChoise(4)}
          className={
            modelChoise === 4
              ? "button_video_choise borderNavMen"
              : "visiblBlock button_video_choise"
          }
          style={{
            textAlign: "center",
          }}
        >
          <div className="icon_2d__Montronix-Model">
            <img src={CIRCLE5} style={{ height: "100%" }} alt="" />
          </div>
          <img
            src={PHOTO4}
            style={{ background: "50% 50% no-repeat" }}
            alt=""
            className="button_model_all_img"
          />
        </button>
      </div>
      <div className="buttons_wrapper_hover_Mon">
        <div
          className={
            selectedHover
              ? "buttons_wrapper_Mon_Off "
              : " buttons_wrapper_Mon_On"
          }
        >
          <div className="slide_button_Mon">{selected}</div>
        </div>
      </div>
    </div>
  );
};
